query allExtHockeyPlayers(
  $first: Int
  $offset: Int
  $filter: HockeyPlayerMappingFilter
) {
  allHockeyPlayerMappings(first: $first, offset: $offset, filter: $filter) {
    nodes {
      extId
      extRef
      feed
      mappingType
      mappingId
      createdAt
      createdBy
      intId
      playerIndex
      mappedEntity {
        name
        source
        playerId
        playerIndex
      }
      playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
        nodes {
          discriminator
          team: hockeyTeamMapping {
            extRef
          }
        }
      }
    }
    totalCount
  }
}
